// src/api/withdrawalsApi.js
import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

// ===== USER APIs =====

/**
 * Create withdrawal request (Bank or UPI)
 * @param {Object} payload - Withdrawal details
 * @param {number} payload.amountBigint - Amount in paise (e.g., 50000 = ₹500)
 * @param {string} payload.method - 'bank' or 'upi'
 * @param {Object} payload.details - Fund account details
 * @param {string} token - User auth token
 */
export const createWithdrawalRequest = async (payload, token) => {
  const resp = await axios.post(`${API}/withdrawals`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

/**
 * Get user's withdrawal history
 * @param {string} token - User auth token
 */
export const getUserWithdrawals = async (token) => {
  const resp = await axios.get(`${API}/withdrawals/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

// ===== ADMIN APIs =====

/**
 * List all withdrawal requests with filters
 * @param {Object} filters - Query params
 * @param {string} filters.status - 'requested', 'approved', 'processed', 'rejected'
 * @param {string} token - Admin auth token
 */
export const listWithdrawals = async (filters = {}, token) => {
  const resp = await axios.get(`${API}/withdrawals`, {
    params: filters,
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

/**
 * Approve withdrawal request (with optional auto payout)
 * @param {string} withdrawalId - Withdrawal ID
 * @param {Object} payload - Approval details
 * @param {boolean} payload.processNow - If true, triggers Razorpay payout immediately
 * @param {string} token - Admin auth token
 */
export const approveWithdrawal = async (withdrawalId, payload, token) => {
  const resp = await axios.post(`${API}/withdrawals/${withdrawalId}/approve`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

/**
 * Reject withdrawal request
 * @param {string} withdrawalId - Withdrawal ID
 * @param {Object} payload - Rejection details
 * @param {string} payload.adminNote - Reason for rejection
 * @param {string} token - Admin auth token
 */
export const rejectWithdrawal = async (withdrawalId, payload, token) => {
  const resp = await axios.post(`${API}/withdrawals/${withdrawalId}/reject`, payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

/**
 * Get withdrawal request by ID
 * @param {string} withdrawalId - Withdrawal ID
 * @param {string} token - Auth token
 */
export const getWithdrawalById = async (withdrawalId, token) => {
  const resp = await axios.get(`${API}/withdrawals/${withdrawalId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return resp.data;
};

export default {
  createWithdrawalRequest,
  getUserWithdrawals,
  listWithdrawals,
  approveWithdrawal,
  rejectWithdrawal,
  getWithdrawalById,
};
